package medicalRecord.components


import antd.badge.badge
import antd.button.button
import antd.card.card
import antd.list.ListComponent
import antd.list.list
import antd.list.listItem
import antd.list.listItemMeta
import antd.message.message
import antd.tag.tag
import com.jingfangpai.common.orm.mapping.MedicalRecord
import com.jingfangpai.common.orm.mapping.enums.*
import kotlinext.js.js
import kotlinx.html.unsafe
import react.*
import medicalRecord.containers.MedicalRecordsPageContext
import react.dom.*
import react.router.dom.useHistory
import user.service.CurrentUserPermission
import com.jingfangpai.common.orm.mapping.enums.UserPermissionMedicalRecord
import com.jingfangpai.common.orm.mapping.enums.UserPermissionContentConnection

external interface MedicalRecordsProps : RProps {

}

data class MedicalRecordsContextData(var placeHolderFunction: (param: String) -> Unit)

val MedicalRecords = functionalComponent<MedicalRecordsProps> { props ->

    val ctx = useContext(MedicalRecordsPageContext)
    val (medicalRecords,setMedicalRecords) = useState<Array<MedicalRecord>>(arrayOf())
    val history = useHistory()

    fun getMedicalRecordList(){
        ctx.getMedicalRecordList({ resp->
            if(resp.ok()){
                setMedicalRecords(resp.data?.toTypedArray()?:arrayOf())
            }else{
                message.error("获取医案列表失败:${resp.message}")
            }
        },{
            message.error("获取医案列表失败:${it.message}")
        })
    }

    useEffectOnce {
        getMedicalRecordList()
    }

    div {
        attrs {
            jsStyle = kotlinext.js.js {
                padding = "40px"
            }
        }

        card {
            attrs{
                title = "验案集"
                extra = if(CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加医案) || CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加私有医案)){
                    buildElement {
                        button {
                            attrs{
                                onClick = {

                                        history.push(LearningRoute.MedicalRecordEdit.link.url.replace(":id","new"))

                                }
                            }
                            +"添加"
                        }
                    }
                } else null
            }
            list<MedicalRecord, ListComponent<MedicalRecord>> {
                attrs {
                    itemLayout = "horizontal"
                    dataSource = medicalRecords
                    header = buildElement {
                        h3 {
                            +"共找到${medicalRecords.size}个医案"
                        }
                    }
                    renderItem = { item, index ->

                        listItem {
                            attrs{
                                /*actions = arrayOf(
                                    buildElement {
                                        a {
                                            attrs{
                                                onClickFunction = {

                                                }
                                            }
                                            +"+关联"
                                        }
                                    }!!
                                )*/
                            }
                            listItemMeta {
                                attrs {
                                    key = "${item.id}"
                                    id = "${item.id}"
                                    className = ""//if(props.keyword.isNotBlank() || contentContainsKey || commentContainsKey) "" else "hidden"

                                    avatar = buildElement {
                                        badge{
                                            attrs{
                                                overflowCount = 300
                                                count = index.toInt()+1
                                            }
                                        }
                                    }
                                    title = buildElement {
                                        div{
                                            h3{
                                                attrs {
                                                    unsafe {
                                                        + "${item.title}"
                                                    }
                                                    jsStyle = kotlinext.js.js {
                                                        display = "inline-block"
                                                    }
                                                }
                                            }
                                            div("meta-info") {
                                                attrs{
                                                    jsStyle = js{
                                                       display = "inline-block"
                                                    }
                                                }
                                                span {
                                                    attrs{
                                                        jsStyle = js{
                                                            marginLeft = "10px"
                                                        }
                                                    }
                                                    +"["
                                                }
                                                span {
                                                    +"医生"
                                                    tag {
                                                        attrs.color = "blue"
                                                        +"${item.doctorName?:""}"
                                                    }
                                                }
                                                span {
                                                    +"患者"
                                                    tag {
                                                        attrs.color = "blue"
                                                        +"${item.patientName?:""}"
                                                    }
                                                }
                                                if(!item.source.isNullOrBlank()){
                                                    span {
                                                        +"出处"
                                                        tag {
                                                            attrs.color = "blue"
                                                            +"${item.source?:""}"
                                                        }
                                                    }
                                                }
                                                span {
                                                    +"]"
                                                }
                                            }
                                            div("actions"){
                                                attrs{
                                                    jsStyle = js{
                                                        display = "inline-block"
                                                        paddingLeft = "10px"
                                                    }
                                                }
                                                if(CurrentUserPermission.hasPerm(UserPermissionContentConnection.关联脉证到医案)){
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            onClick = {

                                                            }
                                                        }
                                                        +"+关联"
                                                    }
                                                }else{
                                                    span{}
                                                }
                                                
                                                // 添加编辑按钮
                                                if(CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加医案) || CurrentUserPermission.hasPerm(UserPermissionMedicalRecord.添加私有医案)){
                                                    button {
                                                        attrs{
                                                            size = "small"
                                                            style = js {
                                                                marginLeft = "8px"
                                                            }
                                                            onClick = {
                                                                history.push(LearningRoute.MedicalRecordEdit.link.url.replace(":id", item.id ?: ""))
                                                            }
                                                        }
                                                        +"编辑"
                                                    }
                                                }
                                            }
                                        }
                                    }
                                    description = buildElement {
                                        div{
                                            div{
                                                attrs.unsafe {
                                                    +"${item.description?:""}"
                                                }
                                            }
                                            div{
                                                attrs{
                                                    jsStyle = js{
                                                        padding = "2px 5px"
                                                        border = "1px solid mediumslateblue"
                                                        display = "inline-block"
                                                    }
                                                }
                                                +"处方：${item.prescriptionContent}"
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}
